import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BackgroundService {
  private randomNumber: number;
  private backgroundPictureCount: number = 8;
  private images: string[] = [];

  constructor() {
    this.prefetchAllBackgrounds();
    this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1;
  }

  getRandomBackground(): string {
    return this.images[this.randomNumber - 1];
  }

  getNewRandomBackground(): string {
    let newRandomNumber: number;
    do {
      newRandomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1;
    } while (newRandomNumber === this.randomNumber);
    this.randomNumber = newRandomNumber;
    return this.getRandomBackground();
  }

  private prefetchAllBackgrounds(): void {
    for (let i = 1; i <= this.backgroundPictureCount; i++) {
      const img = new Image();
      const src = `assets/login-photos/${i}.jpg`;
      img.src = src;
      this.images.push(src);
    }
  }
}
